import { render, staticRenderFns } from "./SearchPeople.vue?vue&type=template&id=67ae1188&"
import script from "./SearchPeople.vue?vue&type=script&lang=ts&"
export * from "./SearchPeople.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports